import client from "../client";

export function getDesiredPlaces(page?: number) {
  return client.get(`/api/v2/desired_places${page ? `?page=${page}` : ""}`);
}
